module.exports = __webpack_public_path__ + "static/media/google-play-it.c701b48c.png";